import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { setReportQuestionFilter } from '../../../../../../../../../../services/redux/actions';
import getTranslatedText from '../../../../../../../../../../services/getTranslatedText';
import { injectIntl } from 'react-intl';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import DeleteIconButton from '../../../../../../../../../../components/DeleteIconButton';
import HideIfPrint from '../../../../../../../../../../components/HideIfPrint';
import ShowIfPrint from '../../../../../../../../../../components/ShowIfPrint';
import { grey400 } from 'material-ui/styles/colors';
import withQueryStringProps from '../../../../../../../../../../components/withQueryStringProps';
import _ from 'lodash';
import DeleteReportQuestionFilterMutation from '../../../../../../../../../../mutations/DeleteReportQuestionFilterMutation';
import {
  QUESTION_TYPE_MULTIPLECHOICE,
  QUESTION_TYPE_PICTURES,
  QUESTION_TYPE_SELECTMANY,
} from '../../../../../../../../../../constants';

const styles = {
  wrapper: {
    marginRight: 24,
    float: 'left',
  },
  filterWrapper: {
    float: 'left',
  },
  deleteButtonWrapper: {
    float: 'left',
  },
  selectField: {
    verticalAlign: 'middle',
    width: 350,
    icon: {
      fill: grey400,
    },
    underline: {
      borderColor: grey400,
    },
  },
  printWrapper: {
    width: 350,
    paddingTop: 4,
    marginBottom: -2,
  }
};

@withQueryStringProps(['questionFilters'])
@injectIntl
@connect()
class OptionPicker extends Component {
  constructor(props) {
    super(props);

    const currentFilter = _.find(
      props.questionFilters,
      { questionId: props.filter.question.id }
    );

    let selectedOptions = (currentFilter && currentFilter.options)
      ? _.map(currentFilter.options, _.parseInt)
      : ['all'];
    const isLocked = props.filter.locked &&
      Array.isArray(props.filter.locked) &&
      props.filter.locked.length;
    // If filter options are locked
    // we cannot use [] to fetch all results from the api
    // To get results for all locked options
    // We must specifically indicate them
    if (isLocked) {
      selectedOptions = props.filter.locked;
    }

    this.state = {
      selectedOptions,
      isLocked,
    };
  }

  handleSelectedChange = (event, index, values) => {
    if (values.length <= 0) {
      if (this.state.isLocked) {
        // ToDo: add notification
        // At least one selection is required
      } else {
        this.setState({ selectedOptions: ['all'] });
      }

    } else if (_.includes(this.state.selectedOptions, 'all') && values.length > 1) {
      this.setState({ selectedOptions: _.without(values, 'all') });
    } else if (_.includes(values, 'all')) {
      this.setState({ selectedOptions: ['all'] });
    } else {
      this.setState({ selectedOptions: values });
    }
  };

  updateQueryStringsAndRedux = () => {
    let options = [];
    if (_.isEqual(this.state.selectedOptions, ['all'])) {
      options = null;
      const remainingFilters = _.filter(
        this.props.questionFilters,
        filter => filter.questionId !== this.props.filter.question.id
      );
      this.props.qs.set({
        questionFilters: remainingFilters.length > 0 ? remainingFilters : null,
      });
    } else {
      options = this.state.selectedOptions;
      const questionFilters = this.props.questionFilters || [];
      if (_.find(this.props.questionFilters, { questionId: this.props.filter.question.id })) {
        const filters = questionFilters.map((filter) => {
          if (filter.questionId === this.props.filter.question.id) {
            return Object.assign({}, filter, { options });
          } else {
            return filter;
          }
        });
        this.props.qs.set({ questionFilters: filters });
      } else {
        this.props.qs.set({
          questionFilters: [
            ...questionFilters,
            {
              questionId: this.props.filter.question.id,
              options,
            },
          ],
        });
      }
    }
    this.props.dispatch(
      setReportQuestionFilter(
        this.props.report.id,
        this.props.filter.question.id,
        options
      )
    );
  };

  deleteFilter = () => {
    DeleteReportQuestionFilterMutation.commit({
      reportId: this.props.report.id,
      questionMongoId: this.props.filter.question.mongoId,
    });
  };

  componentDidMount() {
    this.updateQueryStringsAndRedux();
  }

  componentWillReceiveProps(nextProps) {
    const currentFilter = _.find(
      this.props.questionFilters,
      { questionId: this.props.filter.question.id }
    );
    const nextCurrentFilter = _.find(
      nextProps.questionFilters,
      { questionId: nextProps.filter.question.id }
    );
    if (!_.isEqual(currentFilter, nextCurrentFilter)) {
      this.setState({
        selectedOptions: (nextCurrentFilter && nextCurrentFilter.options)
          ? _.map(nextCurrentFilter.options, _.parseInt)
          : ['all'],
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.selectedOptions, this.state.selectedOptions)) {
      this.updateQueryStringsAndRedux();
    }
  }

  render() {
    const questionType = this.props.filter.question.type;
    const questionTypeIsSupported =
      questionType === QUESTION_TYPE_MULTIPLECHOICE ||
      questionType === QUESTION_TYPE_SELECTMANY ||
      questionType === QUESTION_TYPE_PICTURES;

    const options = (this.props.filter.question.options || [])
      .filter((option) => {
        if (this.state.isLocked && option.value) {
          return this.props.filter.locked.includes(option.value);
        }
        return true;
      });
    const selectedOptions = this.state.selectedOptions;
    const label = this.props.filter.text.length > 0
      ? getTranslatedText(this.props.filter.text, this.props.intl.locale)
      : getTranslatedText(this.props.filter.question.text, this.props.intl.locale);

    return (
      <div style={styles.wrapper}>
        <HideIfPrint>
          <div style={{ height: '100%' }}>
            <div style={Object.assign(styles.filterWrapper, { height: '100%', display: 'flex', alignItems: 'center' })}>
              {questionTypeIsSupported ? (
                <SelectField
                  multiple={true}
                  value={selectedOptions}
                  onChange={this.handleSelectedChange}
                  autoWidth={true}
                  style={styles.selectField}
                  iconStyle={styles.selectField.icon}
                  underlineStyle={styles.selectField.underline}
                  floatingLabelText={label}
                >
                  {!this.state.isLocked &&
                    <MenuItem
                      key="all"
                      value="all"
                      primaryText={this.props.intl.formatMessage({ id: 'selectFilter' })}
                      insetChildren={true}
                      checked={selectedOptions && selectedOptions.indexOf('all') > -1}
                    />
                  }
                  {!this.state.isLocked && <Divider />}
                  {options.map(option =>
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      primaryText={getTranslatedText(option.text, this.props.intl.locale)}
                      insetChildren={true}
                      checked={selectedOptions && selectedOptions.indexOf(option.value) > -1}
                    />
                  )}
                </SelectField>
              ) : (
                <span>Unsupported question type</span>
              )}
            </div>
            {this.props.isAccountAdmin && (
              <div style={styles.deleteButtonWrapper}>
                <DeleteIconButton
                  onTouchTap={this.deleteFilter}
                  style={{
                    marginTop: 10,
                    marginRight: -8,
                    padding: '8px 0px',
                    width: 18,
                  }}
                />
              </div>
            )}
          </div>
        </HideIfPrint>
        <ShowIfPrint>
          <div style={styles.printWrapper}>
            <span>{label}</span>
            <br />
            <span>
              {_.isEqual(this.state.selectedOptions, ['all']) ? (
                this.props.intl.formatMessage({ id: 'selectFilter' })
              ) : (
                <span>
                  {options.filter(opt => _.includes(selectedOptions, opt.value)).map((opt, i) => {
                    if (i === 0) {
                      return (
                        <span key={opt.value}>
                          {getTranslatedText(opt.text, this.props.intl.locale)}
                        </span>
                      );
                    } else {
                      return (
                        <span key={opt.value}>
                          , {getTranslatedText(opt.text, this.props.intl.locale)}
                        </span>
                      );
                    }
                  })}
                </span>
              )}
            </span>
          </div>
        </ShowIfPrint>
      </div>
    );
  }
}

export default createFragmentContainer(
  OptionPicker,
  graphql`
    fragment OptionPicker_report on Report {
      id
    }
    fragment OptionPicker_filter on ReportFilter {
      type
      text {
        language
        text
      }
      question {
        id
        mongoId
        type
        text {
          language
          text
        }
        options {
          value
          text {
            language
            text
          }
        }
      }
      locked
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/OptionPicker/OptionPicker.js